import { LicenseColDefs } from './license-col-defs';

/**
 * Column definitions for grid of listings whose licensing process is managed
 * by Rentalscape
 */
export class StrTOTColDefs extends LicenseColDefs {
  constructor(...args) {
    super(...args);
    this.unitNumberColumn.hide = false;
  }

  licenseColumn = this.textColumn({
    headerName: 'Certificate #',
    pinned: 'left',
    // FIXME: Turn columns into getters and colGroups into functions to solve inheritance issues
    valueGetter: ({ data }) => data?.[this.licenseColumnFieldName],
    width: 140,
  });

  licenseApplicationDateColumn = this.dateColumn({
    headerName: 'Application Date',
    field: 'applicationDate',
    width: 135,
  });

  licenseIssueDateColumn = this.dateColumn({
    headerName: 'Issue Date',
    field: 'issueDate',
    width: 125,
  });

  licenseHolderColumn = this.textColumn({
    headerName: 'Certificate Holder',
    field: 'licenseHolder',
    width: 200,
  });

  licenseHolderEmailColumn = this.textColumn({
    headerName: 'Certificate Holder Email',
    field: 'licenseHolderEmail',
    width: 200,
  });

  propertyDetailsColGroup = {
    headerName: 'Property details',
    children: [
      this.apnColumn,
      this.addressColumn,
      this.unitNumberColumn,
      this.streetAddressColumn,
      this.cityColumn,
      this.stateColumn,
      this.zipColumn,
      this.ownerColumn,
    ],
  };

  strLicenseInfoColGroup = {
    headerName: 'TOT Certificate information',
    children: [
      this.licenseColumn,
      this.licenseStatusColumn,
      this.licenseHolderColumn,
      this.licenseHolderEmailColumn,
      this.licenseApplicationDateColumn,
      this.licenseIssueDateColumn,
    ],
  };

  /**
   * Groups of columns for Pending
   *
   * @override
   */
  columnGroups() {
    return [this.propertyDetailsColGroup, this.strLicenseInfoColGroup];
  }
}
